var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVictory3Start(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 251,
    viewBox: "0 0 371 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.992 84C235.992 84 218.611 142.831 171.996 145.507C126.452 148.137 120.268 91.73 120.009 89.134C120 89.077 120 89.042 120 89.042L120.083 89.03L125.714 88.467C125.714 88.467 126.628 103.514 133.477 117.538C139.735 130.345 150.941 142.302 170.916 141.107C189.174 140.016 201.626 129.46 209.86 117.905C220.512 102.962 224.121 86.353 224.121 86.353L235.992 84Z",
    fill: "url(#paint0_linear_2_8031)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.992 84C235.992 84 218.611 142.831 171.996 145.507C126.452 148.137 120.268 91.73 120.009 89.134L120.083 89.031L125.714 88.468C125.714 88.468 126.628 103.515 133.477 117.539C132.388 118.251 131.889 120.1 134.012 124.603C138.424 133.918 148.781 148.08 179.759 143.233C203.648 139.5 210.377 124.833 209.86 117.907C220.512 102.964 224.121 86.355 224.121 86.355L235.992 84Z",
    fill: "#89C2FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.665 85.7903C235.665 85.7903 235.665 86.2333 235.651 87.0423C235.467 96.6433 232.913 158.364 198.195 160.588C188.71 161.195 180.822 156.225 174.338 148.56C171.898 145.671 169.649 142.406 167.606 138.901C167.599 138.891 167.592 138.891 167.592 138.882C155.88 118.919 150.368 91.5113 149.226 85.3093C149.07 84.4813 148.999 84.0283 148.999 84.0283H157.632C157.632 84.0283 159.164 102.383 164.627 120.623C169.876 138.208 178.779 155.687 193.457 156.573C215.427 157.902 224.72 137.977 228.607 119.063C232.026 102.441 231.274 86.5993 231.274 86.5993L232.182 86.4353L235.665 85.7903Z",
    fill: "url(#paint1_linear_2_8031)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.733 131.938C165.364 134.057 166.315 136.435 167.592 138.881C155.88 118.918 150.368 91.5103 149.226 85.3083L155.164 84.0273H157.633C157.633 84.0273 159.165 102.382 164.628 120.622C163.655 122.241 162.832 125.534 164.733 131.938Z",
    fill: "#89C2FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.651 87.0424C235.467 96.6434 232.913 158.364 198.195 160.588C188.71 161.195 180.822 156.225 174.338 148.56C180.183 154.935 188.434 159.962 199.018 159.702C218.526 159.22 230.231 127.999 229.401 121.143C229.295 120.238 229.011 119.554 228.607 119.063C232.026 102.441 231.274 86.5994 231.274 86.5994L232.182 86.4354L235.651 87.0424Z",
    fill: "#89C2FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2236 1.4726C25.2236 1.4726 20.2396 9.55044 19.1197 21.9234C17.9998 34.2963 22.8119 48.2741 22.8119 48.2741L25.2236 1.4726Z",
    fill: "#4ABAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54855 41.0204C6.54855 41.0204 2.44602 54.0387 4.74316 65.9978C7.04146 77.957 16.1704 83.6953 16.1704 83.6953L6.54855 41.0204Z",
    fill: "#4ABAFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0467283 78.3202C0.0467283 78.3202 -0.677722 93.5714 15.3484 106.652C31.3746 119.732 65.9613 113.133 66.2559 113.133C66.5505 113.133 76.0439 125.214 90.8069 125.035C201.654 123.688 276.113 126.14 280.563 125.785C285.013 125.431 306.397 113.547 306.592 113.524C310.757 113.038 341.208 118.614 355.276 107.772C369.343 96.9289 370.959 79.3186 370.959 79.3186L342.327 93.2413L359.816 79.6453C359.816 79.6453 364.659 74.8928 366.691 63.9481C368.724 53.0034 364.058 40.5204 364.058 40.5204L353.435 46.3745L346.541 48.6728L350.609 39.7467C350.609 39.7467 352.373 35.5043 351.932 23.661C351.489 11.8176 345.021 0.621887 345.021 0.621887C345.021 0.621887 345.258 26.3857 337.901 35.8941C330.543 45.4025 322.985 70.9599 287.679 69.0009C252.374 67.0408 73.6826 90.1165 56.4174 73.4611C39.1521 56.8045 40.0439 81.8564 40.0439 81.8564L28.1547 95.8239L0.0467283 78.3202Z",
    fill: "#4ABAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8353 77.801C77.0756 78.5965 77.7656 79.0413 77.7656 79.0413C77.7656 79.0413 77.5111 81.9895 75.2415 85.4467C73.4705 88.1508 70.4684 91.1735 65.3789 93.3377C66.5986 96.71 68.3375 101.695 68.8785 105.778C69.2075 108.228 69.1124 110.35 68.2102 111.622C68.2102 111.622 66.132 111.961 62.6003 112.269C61.3165 112.385 59.8424 112.491 58.2101 112.576C51.3164 112.947 41.5695 112.947 31.2393 111.303C4.94818 107.114 -0.588354 79.6981 0.0478315 78.3191C0.207164 77.9695 4.68225 78.5736 11.1839 79.6442C2.39198 65.0933 5.45713 45.4198 6.54954 41.018C6.60227 40.7957 6.74096 40.626 6.94156 40.5194C8.46841 39.6712 13.9304 41.8342 21.2162 45.5252C21.1096 44.9417 21.0041 44.3583 20.9193 43.7966C17.5997 23.2644 24.1117 0.89708 25.9778 0.620826C26.1154 0.599047 26.222 0.685018 26.2965 0.907396C31.2817 14.6731 53.0014 41.9832 70.6277 58.4965C71.084 58.9206 71.5287 59.3344 71.9746 59.7482C78.4866 65.6986 84.351 70.0671 88.4765 71.5527C88.4765 71.5527 83.3022 74.8516 75.8353 77.801Z",
    fill: "url(#paint2_linear_2_8031)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.3778 93.3381C66.5974 96.7104 68.3363 101.696 68.8774 105.779C69.2063 108.228 69.1112 110.35 68.2091 111.622C68.2091 111.622 66.1309 111.962 62.5992 112.269C61.3154 112.386 59.8412 112.491 58.2089 112.576C55.9187 107.114 53.8611 100.602 52.9911 94.2391C50.287 74.5437 65.6861 61.6584 70.6277 58.4981C71.3281 58.0522 71.7305 57.8195 71.7305 57.8195L71.9746 59.7498L75.2415 85.4471C73.4705 88.1523 70.4684 91.1751 65.3778 93.3381Z",
    fill: "#BA36FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8242 64.6279C51.8242 64.6279 29.3938 61.7851 21.2163 45.5274C21.1314 45.0712 21.0466 44.6046 20.9721 44.1587C20.9503 44.0315 20.94 43.9146 20.9194 43.7977C17.5998 23.2655 24.1118 0.898141 25.9779 0.621887C24.0155 8.8304 22.2766 35.408 29.552 45.7601C31.3975 48.3908 33.5502 50.7877 35.7671 52.9404C35.7992 52.9725 35.8302 52.9931 35.8623 53.0252C43.4564 60.3431 51.8242 64.6279 51.8242 64.6279Z",
    fill: "url(#paint3_linear_2_8031)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7003 87.6734C36.7003 87.6734 20.6329 89.9109 11.1829 79.6448C11.1829 79.6448 11.1829 79.6345 11.1726 79.6242C2.39096 65.0733 5.45611 45.4203 6.54852 41.0197C6.60124 40.7974 6.73995 40.6277 6.94055 40.5211C6.94055 40.5211 6.70671 45.7711 7.29016 52.3255C7.29016 52.4 7.30048 52.4631 7.30048 52.5273C7.86216 58.7321 9.14599 66.0385 12.0197 71.1715C12.7728 72.5287 13.6429 73.7277 14.639 74.7135C18.9444 78.988 24.301 82.1804 28.6488 84.3228C28.6591 84.3228 28.6591 84.3228 28.6706 84.3331C28.6809 84.3331 28.6809 84.3331 28.6809 84.3331C33.2431 86.581 36.7003 87.6734 36.7003 87.6734Z",
    fill: "url(#paint4_linear_2_8031)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2103 111.622C68.2103 111.622 50.7857 114.422 31.2393 111.305C30.1469 111.135 29.0866 110.913 28.0687 110.658C24.0487 109.672 20.5594 108.124 17.5585 106.214C2.9331 96.9658 -0.461039 79.4243 0.0479093 78.3215C0.0479093 78.3215 0.556859 79.9435 1.73409 82.4149C1.73409 82.4149 1.7444 82.4252 1.75472 82.447C3.91775 87.0184 8.32978 94.4635 15.8918 99.9782C18.3517 101.781 21.1521 103.372 24.3124 104.592C25.2775 104.963 26.2633 105.303 27.2824 105.6C32.4578 107.116 38.2167 107.7 43.8381 107.774H43.8908C54.4538 107.923 64.4551 106.29 68.8774 105.781C69.2064 108.228 69.1113 110.35 68.2103 111.622Z",
    fill: "url(#paint5_linear_2_8031)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.8243 64.6277C51.8243 64.6277 29.3939 61.7849 21.2163 45.5273C21.0467 45.2728 20.9722 44.7845 20.9722 44.1586C21.0249 40.8607 23.4011 33.7125 25.1825 36.5438C27.3042 39.9059 26.4972 44.71 35.7672 52.9403C35.7993 52.9724 35.8303 52.993 35.8624 53.0251C43.4565 60.3429 51.8243 64.6277 51.8243 64.6277Z",
    fill: "url(#paint6_linear_2_8031)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.7002 87.6735C36.7002 87.6735 20.6328 89.911 11.1829 79.645C11.1829 79.645 11.1829 79.6346 11.1726 79.6243C11.0132 79.1475 8.05469 70.2592 10.8012 70.7796C11.0453 70.822 11.4591 70.9596 12.0208 71.1717C12.7739 72.5288 13.644 73.7279 14.6401 74.7137C23.4641 83.4747 36.7002 87.6735 36.7002 87.6735Z",
    fill: "url(#paint7_linear_2_8031)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.2104 111.622C68.2104 111.622 50.7857 114.422 31.2394 111.304C30.147 111.134 29.0867 110.912 28.0688 110.657C24.0488 109.672 20.5595 108.123 17.5585 106.213C15.7761 104.421 11.9165 99.7334 14.7478 99.9455C14.9278 99.9558 15.321 99.9662 15.893 99.9776C18.3529 101.781 21.1533 103.372 24.3135 104.591C25.2787 104.963 26.2645 105.302 27.2836 105.599C42.2058 109.979 62.1018 106.564 68.8786 105.779C69.2065 108.227 69.1113 110.349 68.2104 111.622Z",
    fill: "url(#paint8_linear_2_8031)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3066 16.512C24.3066 16.512 24.4728 34.4822 31.6611 44.4984C38.8495 54.5146 50.5816 63.9485 50.5816 63.9485C50.5816 63.9485 32.0543 53.7787 27.0852 41.2131C22.1161 28.6476 24.3066 16.512 24.3066 16.512Z",
    fill: "#FFC08C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6717 84.333C28.6614 84.3226 28.6614 84.3226 28.6499 84.3226C24.3021 82.1802 18.9455 78.9879 14.6401 74.7134C13.6428 73.7264 12.7739 72.5286 12.0208 71.1714C9.14709 66.0383 7.86326 58.7308 7.30158 52.5271C7.30158 52.4629 7.29126 52.3999 7.29126 52.3254C7.29126 52.3254 8.89147 63.693 14.8991 71.9554C19.3364 78.0571 28.3966 84.1427 28.6717 84.333Z",
    fill: "#FFC08C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.838 107.771C38.2167 107.697 32.4578 107.113 27.2823 105.597C26.2644 105.3 25.2775 104.961 24.3123 104.589C21.152 103.37 18.3516 101.779 15.8917 99.9756C8.3297 94.4608 3.91767 87.0157 1.75464 82.4443C2.11572 83.1023 8.05459 93.6859 19.0944 100.485C29.3502 106.807 41.4939 107.656 43.838 107.771Z",
    fill: "#FFC08C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.8681 21.0461C32.7938 18.5243 30.1527 41.0705 38.4083 51.3148C46.6638 61.5591 65.3642 60.1491 65.3642 58.3174C65.3642 56.4868 38.4541 23.1678 35.8681 21.0461Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.9112 49.3962C13.3976 48.76 15.5262 70.3445 21.5625 75.575C40.2056 91.7307 53.2434 69.526 48.6239 67.3458C26.0216 56.682 21.2083 49.6622 18.9112 49.3962Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.5026 81.1472C3.12337 80.7712 15.5169 98.7082 23.5306 102.036C31.5442 105.363 34.418 105.604 36.3987 105.189C38.3795 104.774 47.4844 92.038 43.8381 91.6356C19.6413 88.9625 9.15395 81.4418 6.5026 81.1472Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.5855 13.9352C27.0543 11.4283 23.9306 26.2015 31.1407 37.7434C34.4971 43.1172 49.8435 44.7873 49.3517 41.7245C48.8599 38.6616 33.8586 15.1927 31.5855 13.9352Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.74139 42.4953C5.0091 43.018 10.6855 59.4648 14.8098 63.5891C18.9341 67.7135 36.87 65.9814 35.0783 62.5873C33.2867 59.192 11.6873 42.0827 8.74139 42.4953Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.755 47.7248C15.0653 47.5609 16.755 52.984 18.3896 54.2437C20.0241 55.5024 26.1224 55.5918 24.7526 53.6465C23.3828 51.7013 18.1248 47.8567 16.755 47.7248Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M35.2043 20.3709C32.7111 19.1581 33.8563 28.4132 35.2043 31.374C36.5523 34.3348 45.859 37.5066 45.6997 34.9091C45.5392 32.3117 37.6573 21.5641 35.2043 20.3709Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M295.164 77.8008C293.923 78.5963 293.233 79.0411 293.233 79.0411C293.233 79.0411 293.488 81.9893 295.757 85.4465C297.528 88.1506 300.53 91.1733 305.621 93.3375C304.401 96.7098 302.663 101.695 302.121 105.778C301.792 108.228 301.888 110.349 302.79 111.622C302.79 111.622 304.868 111.961 308.4 112.268C309.683 112.385 311.158 112.491 312.791 112.576C319.685 112.947 329.432 112.947 339.761 111.303C366.052 107.113 371.588 79.6979 370.952 78.3189C370.793 77.9693 366.318 78.5734 359.816 79.644C368.608 65.0932 365.543 45.4196 364.45 41.0179C364.398 40.7955 364.259 40.6258 364.058 40.5192C362.532 39.671 357.07 41.834 349.784 45.525C349.889 44.9415 349.996 44.3581 350.081 43.7964C353.4 23.2642 346.888 0.896897 345.022 0.620643C344.885 0.598864 344.778 0.684835 344.705 0.907213C339.719 14.6729 318 41.983 300.373 58.4963C299.917 58.9204 299.472 59.3343 299.027 59.7481C292.514 65.6984 286.65 70.0669 282.525 71.5525C282.522 71.5536 287.698 74.8514 295.164 77.8008Z",
    fill: "url(#paint9_linear_2_8031)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M305.621 93.3379C304.401 96.7103 302.663 101.695 302.121 105.779C301.792 108.228 301.888 110.35 302.79 111.622C302.79 111.622 304.868 111.962 308.4 112.269C309.683 112.386 311.158 112.491 312.791 112.576C315.081 107.114 317.139 100.602 318.009 94.2389C320.713 74.5435 305.314 61.6582 300.371 58.4979C299.671 58.052 299.268 57.8193 299.268 57.8193L299.024 59.7496L295.757 85.4469C297.529 88.1522 300.53 91.1749 305.621 93.3379Z",
    fill: "#BA36FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M319.176 64.6277C319.176 64.6277 341.606 61.7849 349.784 45.5272C349.869 45.071 349.953 44.6045 350.028 44.1586C350.049 44.0313 350.06 43.9144 350.081 43.7975C353.4 23.2653 346.888 0.897958 345.022 0.621704C346.985 8.83022 348.723 35.4079 341.448 45.7599C339.603 48.3906 337.45 50.7875 335.233 52.9402C335.201 52.9723 335.169 52.9929 335.138 53.025C327.544 60.3429 319.176 64.6277 319.176 64.6277Z",
    fill: "url(#paint10_linear_2_8031)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M334.299 87.6732C334.299 87.6732 350.366 89.9107 359.816 79.6446C359.816 79.6446 359.816 79.6343 359.826 79.624C368.608 65.0731 365.543 45.4201 364.451 41.0196C364.398 40.7972 364.259 40.6275 364.059 40.5209C364.059 40.5209 364.292 45.7709 363.709 52.3253C363.709 52.3998 363.699 52.4629 363.699 52.5271C363.137 58.7319 361.853 66.0383 358.979 71.1713C358.226 72.5285 357.356 73.7275 356.36 74.7133C352.055 78.9878 346.698 82.1802 342.35 84.3226C342.34 84.3226 342.34 84.3226 342.33 84.3329C342.319 84.3329 342.319 84.3329 342.319 84.3329C337.756 86.5808 334.299 87.6732 334.299 87.6732Z",
    fill: "url(#paint11_linear_2_8031)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M302.79 111.622C302.79 111.622 320.214 114.422 339.761 111.304C340.853 111.135 341.914 110.912 342.931 110.658C346.951 109.672 350.441 108.123 353.442 106.214C368.067 96.9656 371.461 79.4241 370.952 78.3214C370.952 78.3214 370.443 79.9433 369.266 82.4147C369.266 82.4147 369.256 82.425 369.245 82.4468C367.082 87.0182 362.67 94.4633 355.108 99.978C352.648 101.781 349.848 103.372 346.688 104.592C345.723 104.963 344.737 105.302 343.718 105.599C338.542 107.116 332.783 107.699 327.162 107.774H327.109C316.546 107.923 306.545 106.289 302.123 105.78C301.793 108.228 301.888 110.35 302.79 111.622Z",
    fill: "url(#paint12_linear_2_8031)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M319.176 64.6275C319.176 64.6275 341.606 61.7848 349.784 45.5271C349.953 45.2726 350.028 44.7843 350.028 44.1584C349.975 40.8606 347.599 33.7124 345.818 36.5437C343.697 39.9057 344.503 44.7098 335.233 52.9401C335.201 52.9722 335.169 52.9928 335.138 53.0249C327.544 60.3427 319.176 64.6275 319.176 64.6275Z",
    fill: "url(#paint13_linear_2_8031)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M334.299 87.6733C334.299 87.6733 350.366 89.9109 359.816 79.6448C359.816 79.6448 359.816 79.6344 359.826 79.6241C359.986 79.1473 362.944 70.259 360.198 70.7794C359.954 70.8218 359.54 70.9594 358.978 71.1715C358.225 72.5287 357.355 73.7277 356.359 74.7135C347.535 83.4745 334.299 87.6733 334.299 87.6733Z",
    fill: "url(#paint14_linear_2_8031)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M302.79 111.621C302.79 111.621 320.214 114.422 339.761 111.304C340.853 111.134 341.913 110.912 342.931 110.657C346.951 109.672 350.441 108.123 353.442 106.213C355.223 104.42 359.084 99.7333 356.252 99.9453C356.072 99.9556 355.679 99.966 355.107 99.9774C352.647 101.781 349.847 103.372 346.687 104.591C345.721 104.963 344.736 105.302 343.716 105.599C328.794 109.979 308.898 106.564 302.121 105.779C301.792 108.227 301.888 110.349 302.79 111.621Z",
    fill: "url(#paint15_linear_2_8031)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M346.692 16.5118C346.692 16.5118 346.526 34.482 339.338 44.4982C332.149 54.5144 320.417 63.9483 320.417 63.9483C320.417 63.9483 338.945 53.7785 343.914 41.2129C348.883 28.6497 346.692 16.5118 346.692 16.5118Z",
    fill: "#FFC08C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M342.327 84.3328C342.338 84.3225 342.338 84.3225 342.348 84.3225C346.696 82.1801 352.052 78.9877 356.358 74.7132C357.355 73.7262 358.224 72.5284 358.977 71.1712C361.851 66.0382 363.135 58.7306 363.696 52.5269C363.696 52.4627 363.707 52.3997 363.707 52.3252C363.707 52.3252 362.106 63.6929 356.099 71.9552C351.664 78.0569 342.604 84.1425 342.327 84.3328Z",
    fill: "#FFC08C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M327.161 107.771C332.782 107.697 338.541 107.113 343.717 105.597C344.735 105.3 345.721 104.961 346.687 104.589C349.847 103.369 352.647 101.778 355.107 99.9754C362.669 94.4606 367.081 87.0155 369.244 82.4442C368.883 83.1021 362.944 93.6857 351.904 100.484C341.649 106.807 329.505 107.655 327.161 107.771Z",
    fill: "#FFC08C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M335.132 21.0459C338.206 18.5241 340.847 41.0703 332.592 51.3146C324.336 61.5589 305.636 60.1489 305.636 58.3172C305.636 56.4866 332.546 23.1677 335.132 21.0459Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M352.089 49.396C357.603 48.7599 355.474 70.3443 349.438 75.5748C330.795 91.7305 317.757 69.5259 322.376 67.3456C344.978 56.6818 349.791 49.662 352.089 49.396Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.498 81.1469C367.877 80.771 355.482 98.7079 347.47 102.036C339.456 105.363 336.582 105.604 334.601 105.189C332.621 104.774 323.516 92.0377 327.161 91.6354C351.358 88.9623 361.845 81.4415 364.498 81.1469Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M339.414 13.935C343.946 11.4281 347.069 26.2014 339.859 37.7432C336.503 43.117 321.157 44.7872 321.648 41.7243C322.14 38.6614 337.14 15.1925 339.414 13.935Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M362.258 42.4951C365.99 43.0178 360.314 59.4646 356.189 63.589C352.065 67.7133 334.129 65.9813 335.921 62.5871C337.712 59.1918 359.312 42.0825 362.258 42.4951Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.245 47.7246C355.935 47.5607 354.245 52.9838 352.61 54.2436C350.976 55.5033 344.878 55.5916 346.247 53.6463C347.616 51.7011 352.875 47.8565 354.245 47.7246Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M335.795 20.3707C338.288 19.1579 337.143 28.413 335.795 31.3738C334.447 34.3347 325.14 37.5064 325.299 34.909C325.46 32.3115 333.343 21.5639 335.795 20.3707Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M313.886 78.6344V85.3023C313.886 106.423 296.616 123.692 275.516 123.692H94.0406C72.9411 123.692 55.6609 106.423 55.6609 85.3023V78.6344C55.6609 71.8197 59.4172 65.8201 66.0233 60.655C70.1762 57.3995 75.4675 54.4674 81.6757 51.8584C81.6964 51.8481 81.717 51.8378 81.7491 51.8275C81.8328 51.7965 81.968 51.7438 82.1663 51.6704C89.2309 48.7383 97.4325 46.2233 106.47 44.136C116.425 41.8193 127.381 40.0242 138.891 38.7301H138.901C145.131 38.0205 151.517 37.4783 158.008 37.0714C171.656 36.2163 185.724 36.0283 199.571 36.4868C199.685 36.4971 199.81 36.5075 199.926 36.5075H199.936C202.608 36.6015 205.258 36.7161 207.909 36.8616C213.982 37.1849 219.982 37.6342 225.847 38.2177C237.899 39.4075 249.409 41.1396 259.906 43.4149C269.788 45.5539 278.763 48.1628 286.432 51.2624C286.735 51.377 287.027 51.4916 287.277 51.5959C287.862 51.8355 288.435 52.0762 288.999 52.3261C293.121 54.1212 296.826 56.0618 300.04 58.1595C308.794 63.868 313.886 70.6929 313.886 78.6344Z",
    fill: "url(#paint16_linear_2_8031)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M194.702 117.345C190.788 117.286 244.991 95.2089 260.281 93.2407C275.571 91.2725 296.163 103.026 292.54 107.623C288.916 112.22 270.975 118.493 194.702 117.345Z",
    fill: "#B2ABFF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M67.2577 62.769C59.6028 68.5703 71.8531 104.115 134.25 112.455C196.646 120.793 312.602 78.1934 295.279 61.4015C277.957 44.6085 116.877 25.1653 67.2577 62.769Z",
    fill: "#C4BAFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M69.0516 63.2823C60.5749 68.4165 96.4569 85.4239 142.339 84.077C188.221 82.7301 229.349 46.4916 218.153 44.0477C206.958 41.6039 114.976 35.469 69.0516 63.2823Z",
    fill: "#C4BAFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M313.886 78.6359V85.3072C313.886 86.7607 313.801 88.2027 313.641 89.6127C311.669 107.08 297.861 121.091 280.488 123.371C278.864 123.583 277.2 123.688 275.514 123.688H94.0405C93.0329 123.688 92.0356 123.646 91.0498 123.571C91.0395 123.571 91.0395 123.571 91.0395 123.561C71.3235 122.023 55.6584 105.414 55.6584 85.3061V78.6347C55.6584 77.9034 55.7009 77.1812 55.7857 76.4706C56.4964 70.542 60.1232 65.2714 66.0197 60.6576C63.9621 63.0751 61.6604 68.6117 60.717 75.4103C58.5643 90.9584 63.4635 113.114 94.4222 119.795C95.1111 119.944 102.748 120.06 114.584 120.145C155.384 120.41 246.095 120.24 273.69 119.339C278.177 119.202 280.998 119.032 281.666 118.851C306.822 111.925 310.344 91.2553 307.67 75.8447C307.67 75.8241 307.67 75.8126 307.67 75.8126C306.228 67.509 302.983 60.7425 300.373 58.4935C300.236 58.3765 300.129 58.2711 300.034 58.1542C308.795 63.8718 313.886 70.6922 313.886 78.6359Z",
    fill: "url(#paint17_linear_2_8031)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M281.666 118.852C275.685 120.495 97.8806 120.538 94.4223 119.795C63.4647 113.113 58.5644 90.9581 60.7171 75.4099H60.7274C60.7274 75.4099 56.6547 113.103 95.3657 117.259C122.58 120.176 273.35 119.349 288.623 112.773C307.893 104.48 307.681 76.915 307.671 75.8443C310.344 91.2561 306.822 111.926 281.666 118.852Z",
    fill: "#676687"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M280.489 123.371C278.866 123.583 277.201 123.688 275.515 123.688H94.0405C93.0329 123.688 92.0357 123.646 91.0499 123.571C91.0396 123.571 91.0396 123.571 91.0396 123.561C90.0526 122.723 92.1526 121.142 98.5477 120.613C99.6825 120.517 105.569 120.348 114.583 120.146C155.383 120.411 246.093 120.241 273.689 119.34C277.592 119.574 279.914 119.881 280.254 120.263C281.305 121.461 281.242 122.5 280.489 123.371Z",
    fill: "#6E1A46"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M286.428 51.2614C277.508 47.8467 246.758 38.0678 182.535 38.9481C113.776 39.8903 86.0762 50.169 82.1628 51.6649C131.383 31.2382 236.485 31.111 286.428 51.2614Z",
    fill: "#F194FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M102.316 50.9721C98.0468 52.6904 123.309 66.174 136.409 64.4649C149.511 62.7558 174.663 43.4984 168.306 42.7819C161.95 42.0655 122.231 42.9584 102.316 50.9721Z",
    fill: "#C4BAFF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M306.963 89.3379C305.658 88.9986 297.224 103.689 302.394 103.734C307.565 103.778 310.737 90.3202 306.963 89.3379Z",
    fill: "#290C63"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M301.818 97.4117C302.422 97.0769 303.367 98.7264 304.088 98.4765C304.811 98.2255 307.668 95.0148 307.992 96.0166C308.316 97.0185 305.104 104.575 302.321 103.573C299.537 102.571 301.645 97.5079 301.818 97.4117Z",
    fill: "#676687"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7661 67.7574C81.7661 67.7574 86.8086 67.3081 89.8038 66.4094C92.7991 65.5107 94.2973 61.1743 94.2973 61.1743C94.2973 61.1743 92.7498 64.5123 81.7661 67.7574Z",
    fill: "#5A13A1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8916 65.9784C93.8916 65.9784 96.0443 66.4655 97.9357 66.3154C99.827 66.1652 100.482 65.3788 100.482 65.3788C100.482 65.3788 94.3971 66.0345 93.8916 65.9784Z",
    fill: "#5A13A1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7661 67.7574C81.7661 67.7574 87.0585 65.6047 89.7167 64.032C92.3749 62.4593 94.2973 61.1755 94.2973 61.1755C94.2973 61.1755 91.9577 65.6792 81.7661 67.7574Z",
    fill: "#C669D6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8916 65.978C93.8916 65.978 95.9251 65.9825 97.8061 65.7774C99.6883 65.5733 100.482 65.3785 100.482 65.3785C100.482 65.3785 96.5877 65.3326 93.8916 65.978Z",
    fill: "#C669D6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7716 72.4115C10.455 72.8964 17.3865 79.758 17.9058 77.6145C18.4251 75.4709 14.6813 72.0114 12.7716 72.4115Z",
    fill: "#7A1032"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0565 75.6193C13.9384 75.343 15.2177 75.9058 15.7232 75.4943C16.2287 75.0828 15.8516 73.6465 16.5026 74.1589C17.1537 74.6713 18.433 77.3524 17.6925 77.9462C16.952 78.54 14.4565 76.5558 14.0565 75.6193Z",
    fill: "#FCF800"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M314.312 55.1538C309.526 56.0375 303.978 62.9152 309.67 62.9645C315.361 63.0138 320.653 53.9823 314.312 55.1538Z",
    fill: "#E1ABFF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M329.14 49.6847C327.179 50.3381 326.644 54.1276 329.091 52.7796C331.536 51.4316 331.985 48.7356 329.14 49.6847Z",
    fill: "#E1ABFF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.6585 102.204C51.5823 100.224 43.3245 102.837 47.9176 105.341C52.5108 107.846 61.0036 104.8 55.6585 102.204Z",
    fill: "#E1ABFF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8616 2.35809C26.8616 2.35809 29.913 13.3899 35.908 21.4024C41.9019 29.4149 49.8319 36.2456 49.8319 36.2456C49.8319 36.2456 34.8867 20.5324 26.8616 2.35809Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M319.704 37.9839C319.498 38.2131 327.068 31.7378 332.685 23.9488C338.301 16.161 342.327 6.20325 342.327 6.20325C342.327 6.20325 330.491 25.9743 319.704 37.9839Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.4598 93.2931C66.7924 94.084 74.0656 106.735 76.7983 104.002C79.5322 101.269 73.8787 91.9829 69.4598 93.2931Z",
    fill: "#ABAAD4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.581 97.1123C78.2713 97.149 78.8593 104.489 81.4797 102.392C84.1001 100.296 82.9401 97.0745 80.581 97.1123Z",
    fill: "#ABAAD4"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M271.278 50.2614C267.644 50.0849 265.886 59.3697 271.278 59.3697C276.669 59.3697 274.948 50.4391 271.278 50.2614Z",
    fill: "#ABAAD4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2559 113.133C66.2559 113.133 63.1071 110.584 60.2769 105.723C57.4467 100.862 56.2466 91.9952 56.2466 91.9952C56.2466 91.9952 57.5362 100.199 61.5573 105.768C65.5785 111.336 66.6697 112.144 66.6697 112.144L66.2559 113.133Z",
    fill: "#4A7AFF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M301.458 113.524C301.458 113.524 306.062 109.361 308.891 104.235C311.719 99.1092 312.698 94.7579 312.698 94.7579C312.698 94.7579 311.723 110.792 306.593 113.524C301.462 116.255 301.458 113.524 301.458 113.524Z",
    fill: "#4ABAFF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M244.476 75.9218L244.461 75.7831C245.478 75.6593 246.415 75.5825 247.272 75.5504C246.472 75.7086 245.54 75.8324 244.476 75.9218ZM210.222 88.0299C208.191 87.8259 206.863 86.5959 206.242 84.3412C206.361 83.6053 206.555 82.8648 206.824 82.1163C209.409 77.373 212.33 75.0013 215.585 75.0013C217.887 75.0013 219.346 75.9734 219.962 77.9186C219.874 79.6529 219.487 81.1545 218.803 82.4246C216.132 86.181 213.481 88.0598 210.848 88.0598C210.632 88.0598 210.424 88.0506 210.222 88.0299ZM266.837 96.7359L277.829 104.603L294.01 71.794L292.943 67.7855L284.077 60.5765L278.552 72.2331L270.044 60.9903L262.034 67.9506L262.791 71.9614L271.973 82.5668L266.039 92.4798L266.837 96.7359ZM228.586 66.8283L234.361 104.324L246.526 102.651L245.967 91.212L255.062 104.268L264.465 98.0186L263.69 93.7499C260.798 90.0015 258.581 87.1771 257.041 85.2754C260.247 82.6241 261.921 79.8512 262.065 76.9546C262.117 76.0249 262.067 75.148 261.913 74.325L261.164 70.2913C261.046 69.6539 260.866 69.0498 260.624 68.4767C257.692 63.832 253.675 61.2528 248.575 60.7404C248.357 60.7187 248.139 60.7003 247.917 60.6866L245.045 60.549C236.058 61.3044 230.432 62.0782 228.167 62.8691L228.586 66.8283ZM136.27 95.1174C139.859 101.962 144.62 105.077 150.553 104.463C158.775 103.441 164.075 99.1535 166.456 91.6018L166.652 87.3972L157.204 83.337C155.27 85.4737 153.567 86.6521 152.095 86.8733C151.599 86.9341 151.13 86.9433 150.689 86.8986C148.327 86.6613 146.766 84.9086 146.006 81.6406C146.92 78.6121 149.077 76.7631 152.478 76.0903C154.226 75.8301 155.974 76.527 157.723 78.1823C157.723 78.1823 165.58 71.6783 165.585 71.6794V71.6806C165.585 71.6806 165.585 71.6817 165.585 71.6828C165.585 71.6828 165.585 71.684 165.585 71.6851C165.563 71.8938 165.541 72.1035 165.519 72.3156L165.312 76.3688C168.864 76.0903 172.277 75.9504 175.55 75.9504L175.607 80.1355C175.458 91.463 175.68 99.5248 176.276 104.324H186.598C186.763 100.163 186.841 95.5988 186.835 90.632L186.83 86.4366C186.825 83.0975 186.782 79.575 186.699 75.8679C189.475 75.869 192.531 75.939 195.867 76.0765C195.4 77.8303 195.09 79.7171 194.937 81.7357C194.937 81.8137 194.936 81.8916 194.936 81.9695C194.936 82.2137 194.939 82.4556 194.944 82.6963L195.031 86.8539C195.081 89.2381 195.375 91.3977 195.917 93.3326C197.926 100.122 202.278 103.786 208.975 104.324C214.722 104.324 219.445 102.511 223.147 98.8841C227.722 93.1928 230.01 87.1301 230.01 80.6937C230.028 80.2937 230.039 79.8982 230.039 79.5085C230.039 78.6935 229.998 77.9003 229.916 77.1277L229.503 73.2452L229.484 73.0664C229.336 71.6782 229.054 70.36 228.638 69.1106C226.28 63.9581 222.29 61.0992 216.667 60.5352C216.142 60.4825 215.601 60.4504 215.048 60.4367C213.059 60.4367 210.95 60.7955 208.721 61.5142C202.366 64.1506 198.192 68.6268 196.196 74.9428L196.125 72.0382C195.629 68.5947 194.965 64.6813 194.136 60.2991C183.768 60.2991 174.819 60.3725 167.287 60.5203C166.86 62.3957 166.471 64.6355 166.118 67.2376C163.572 63.0823 160.162 60.7897 155.887 60.361C154.633 60.2349 153.304 60.2693 151.901 60.4654C149.784 60.7599 148.209 61.2207 147.178 61.8466C139.76 65.9205 135.631 71.3091 134.792 78.0114C134.791 78.016 134.791 78.0195 134.791 78.0241L134.277 82.122C134.17 82.9863 134.116 83.8712 134.116 84.7779C134.116 85.9208 134.202 87.098 134.374 88.3096C134.54 90.5048 135.171 92.7744 136.27 95.1174ZM78.52 71.4593L90.321 104.435L101.591 104.379L111.329 73.3232L111.049 75.4484L116.099 75.1698V89.6955L111.324 90.491L110.575 94.7265L111.217 104.603H132.894L133.422 100.27L134.554 90.2159L128.808 89.5809L128.142 75.4266C129.777 75.4438 131.454 75.5171 133.172 75.6455L133.699 71.5992L132.731 60.439L113.147 61.1302L112.416 65.0722L112.2 66.7045L100.329 60.4401L99.4694 64.3753L96.6186 77.6721C93.8618 67.4725 92.3361 62.0976 92.0427 61.5451C85.1914 64.6023 81.0384 66.5727 79.5849 67.4565L78.52 71.4593Z",
    fill: "url(#paint18_linear_2_8031)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M112.399 66.8083L100.329 60.443L97.0553 75.7034L96.6255 77.7037C96.4432 77.0262 96.2701 76.3728 96.0959 75.7447C93.6658 66.7911 92.3177 62.0627 92.0449 61.5423C85.1913 64.6006 81.0418 66.5687 79.5872 67.4536L82.8609 76.6136L91.2689 100.108L102.429 100.049L104.182 94.4692L107.968 82.3828L110.142 75.4386L112.076 69.2877L112.787 67.0146L112.399 66.8083Z",
    fill: "url(#paint19_linear_2_8031)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M128.81 89.5837L128.164 75.9017L127.949 71.3797C129.809 71.3797 131.727 71.4542 133.703 71.5952L132.736 60.443L113.151 61.1296L112.399 66.8095L112.077 69.29L111.797 71.406L116.798 71.1332V89.5849L111.325 90.4939L111.962 100.274H133.422L134.555 90.213L128.81 89.5837Z",
    fill: "url(#paint20_linear_2_8031)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M157.206 83.3346C155.271 85.4759 153.569 86.6497 152.097 86.8732C148.816 87.2778 146.757 85.3853 145.905 81.1853C145.921 79.7215 146.111 78.432 146.492 77.3086C147.418 74.4487 149.534 72.688 152.816 72.0426C154.543 71.7859 156.272 72.4725 158.008 74.1093L166.092 67.4208L166.183 67.3463C166.158 67.3131 166.142 67.2718 166.116 67.2386C162.817 61.8648 158.081 59.6078 151.897 60.4675C149.781 60.7655 148.209 61.2194 147.176 61.8476C140.389 65.5764 136.354 70.4034 135.074 76.3228C134.884 77.2077 134.752 78.1167 134.685 79.051C134.57 80.6718 134.636 82.366 134.884 84.1347C135.049 86.3092 135.677 88.5571 136.76 90.8806C137.066 91.4675 137.388 92.0303 137.71 92.5587C141.141 98.164 145.547 100.694 150.904 100.131C159.047 99.1223 164.288 94.8731 166.653 87.3993L157.206 83.3346Z",
    fill: "url(#paint21_linear_2_8031)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M186.694 75.5876C186.669 74.3553 186.636 73.099 186.595 71.8175C189.472 71.8175 192.646 71.892 196.127 72.041C195.631 68.593 194.961 64.683 194.135 60.3019C183.768 60.3019 174.824 60.3764 167.283 60.5254C166.861 62.4019 166.473 64.6337 166.118 67.2381C166.11 67.2965 166.102 67.3619 166.092 67.4203C165.894 68.9254 165.704 70.5623 165.521 72.3138C169.035 72.041 172.416 71.9 175.657 71.9L175.715 76.0415C175.69 77.926 175.674 79.7279 175.666 81.4313C175.65 89.8553 175.882 96.0475 176.377 99.9907H186.595C186.76 95.816 186.834 91.2355 186.826 86.2423C186.826 85.3906 186.826 84.5228 186.818 83.6379C186.802 81.0599 186.761 78.373 186.694 75.5876Z",
    fill: "url(#paint22_linear_2_8031)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M228.633 69.1146C226.062 63.4761 221.532 60.5828 215.051 60.443C213.059 60.443 210.951 60.7984 208.719 61.5182C200.287 65.0155 195.69 71.7522 194.938 81.7397C194.93 83.0626 194.997 84.3189 195.137 85.5099C195.277 86.7914 195.508 87.9904 195.823 89.1137C197.816 95.8344 202.122 99.4635 208.752 99.9931C210.927 99.9931 212.943 99.7363 214.821 99.1999C217.863 98.3654 220.516 96.8271 222.782 94.6113C223.096 94.2227 223.394 93.8342 223.683 93.4456C224.195 92.7509 224.674 92.0482 225.121 91.3456C228.089 86.6665 229.577 81.7558 229.577 76.5975C229.707 73.8763 229.393 71.3797 228.633 69.1146ZM210.851 88.0626C207.974 88.0626 206.337 86.2687 205.932 82.6728C205.825 81.1437 206.048 79.5893 206.627 78.0098C209.182 73.3146 212.075 70.9658 215.299 70.9658C218.407 70.9658 219.962 72.7598 219.962 76.3476C220.077 78.7617 219.689 80.7872 218.804 82.4241C216.133 86.1861 213.479 88.0626 210.851 88.0626Z",
    fill: "url(#paint23_linear_2_8031)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M263.694 93.7513C258.402 86.8977 255.377 83.1367 254.6 82.4581C258.916 79.4319 261.148 76.2498 261.313 72.8935C261.403 71.2566 261.181 69.7848 260.626 68.4792C257.568 63.635 253.335 61.0387 247.92 60.6914L245.042 60.5504C236.057 61.3024 230.434 62.0795 228.169 62.8739L233.378 96.6937L233.882 99.9928L240.149 99.1331L245.927 98.3398L245.374 87.0146L254.385 99.9446L263.694 93.7513ZM244.324 75.9358L243.886 71.7358C246.002 71.479 247.772 71.4217 249.193 71.5707C250.4 71.7943 250.987 72.3559 250.929 73.2569C250.854 74.6955 248.656 75.5885 244.324 75.9358Z",
    fill: "url(#paint24_linear_2_8031)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M284.079 60.5751L278.548 72.2316L270.042 60.9889L262.031 67.9502L273.084 80.7141L266.04 92.4783L276.919 100.274L292.941 67.7852L284.079 60.5751Z",
    fill: "url(#paint25_linear_2_8031)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M92.0461 61.5415C92.3189 62.0619 93.6658 66.7914 96.097 75.7439C91.1038 75.9594 86.6723 76.2735 82.8609 76.6117L79.5872 67.4517C81.0429 66.5668 85.1925 64.5998 92.0461 61.5415Z",
    fill: "#DFE300"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M127.95 71.3789L128.165 75.901C124.222 75.6947 120.428 75.5709 116.798 75.4964V71.1313L111.796 71.4042L112.077 69.2881L110.143 75.4391C105.447 75.4391 101.074 75.5388 97.0564 75.7038L100.33 60.4434L112.401 66.8087L113.152 61.1289L132.737 60.4423L133.704 71.5944C131.727 71.4534 129.809 71.3789 127.95 71.3789Z",
    fill: "#DFE300"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M186.595 71.8172C186.719 75.9759 186.793 79.911 186.818 83.6387C183.04 82.8283 179.32 82.1016 175.666 81.431C175.674 79.7276 175.691 77.9257 175.715 76.0412L175.657 71.8997C172.416 71.8997 169.035 72.0407 165.522 72.3135C165.704 70.5609 165.894 68.924 166.092 67.42L158.008 74.1086C156.272 72.4717 154.544 71.7851 152.816 72.0418C149.534 72.6872 147.417 74.4479 146.492 77.3079C142.573 76.9032 138.763 76.58 135.075 76.3243C136.357 70.405 140.39 65.5768 147.178 61.8491C148.212 61.221 149.782 60.7659 151.898 60.469C158.082 59.6093 162.819 61.8663 166.118 67.2401C166.473 64.6357 166.862 62.4039 167.283 60.5274C174.822 60.3784 183.768 60.3039 194.135 60.3039C194.961 64.685 195.631 68.5961 196.127 72.043C192.647 71.8917 189.472 71.8172 186.595 71.8172Z",
    fill: "#DFE300"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M228.633 69.1139C226.062 63.4753 221.532 60.5821 215.051 60.4423C213.059 60.4423 210.951 60.7976 208.719 61.5175C200.287 65.0148 195.69 71.7515 194.938 81.739C194.93 83.0618 194.997 84.3181 195.137 85.5091C204.362 87.6916 213.902 90.312 223.683 93.4448C227.61 88.1456 229.577 82.5322 229.577 76.5968C229.707 73.8755 229.393 71.3789 228.633 69.1139ZM218.803 82.4233C216.133 86.1843 213.478 88.0607 210.85 88.0607C207.973 88.0607 206.336 86.2668 205.931 82.6709C205.823 81.1418 206.047 79.5874 206.626 78.0079C209.181 73.3127 212.074 70.964 215.297 70.964C218.406 70.964 219.961 72.7579 219.961 76.3457C220.076 78.761 219.688 80.7864 218.803 82.4233Z",
    fill: "#DFE300"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M263.694 93.7506C258.402 86.897 255.377 83.136 254.6 82.4574C258.916 79.4313 261.148 76.2492 261.313 72.8929C261.403 71.256 261.181 69.7842 260.626 68.4786C257.568 63.6344 253.335 61.038 247.92 60.6907L245.042 60.5497C236.057 61.3017 230.434 62.0789 228.169 62.8732L233.378 96.6931C235.627 97.4783 237.875 98.2887 240.149 99.1324L245.927 98.3391L245.374 87.0139L254.385 99.9439L263.694 93.7506ZM244.324 75.9351L243.886 71.7351C246.002 71.4784 247.772 71.421 249.193 71.5701C250.4 71.7936 250.987 72.3553 250.929 73.2562C250.854 74.6948 248.656 75.5878 244.324 75.9351Z",
    fill: "#DFE300"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M292.942 67.7833L276.921 100.272L266.041 92.4765L273.084 80.7122L262.031 67.9483L270.042 60.987L278.549 72.2308L284.079 60.5743L292.942 67.7833Z",
    fill: "#DFE300"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.968 82.3824L104.182 94.4688C103.075 93.4933 101.933 91.9974 101.23 89.7484C99.8913 85.4831 105.348 83.2169 107.968 82.3824Z",
    fill: "#E3C1C1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M101.503 84.3488C100.447 84.6984 100.125 78.5624 101.549 79.9173C102.974 81.271 104.558 83.3389 101.503 84.3488Z",
    fill: "#E3C1C1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M139.532 84.7721C139.681 88.3852 138.407 91.2784 137.713 92.5599C137.391 92.0315 137.067 91.4687 136.763 90.8818C135.679 88.5583 135.051 86.3104 134.886 84.1359C134.638 82.3672 134.572 80.6719 134.688 79.0522C136.406 79.5726 139.383 81.2507 139.532 84.7721Z",
    fill: "#E3C1C1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M186.826 86.2434C185.545 84.391 184.281 81.1917 184.52 78.6791C184.76 76.1332 185.826 75.5876 186.695 75.5876C186.761 78.3742 186.802 81.0599 186.818 83.6402C186.826 84.524 186.826 85.3917 186.826 86.2434Z",
    fill: "#E3C1C1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M183.209 84.3599C182.164 83.687 181.039 88.5965 182.761 89.0103C184.483 89.423 185.241 85.6689 183.209 84.3599Z",
    fill: "#E3C1C1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M225.119 91.3439C224.673 92.0466 224.193 92.7492 223.68 93.4439C223.392 93.8325 223.094 94.221 222.78 94.6096C220.514 96.8254 217.861 98.3625 214.819 99.1982C215.274 96.4288 216.844 91.2201 221.374 90.9897C222.912 90.906 224.144 91.063 225.119 91.3439Z",
    fill: "#E3C1C1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2703 100.48C93.2703 100.48 94.7513 96.9324 96.99 97.7932C99.2286 98.6541 99.4705 100.963 99.4705 100.963L93.2703 100.48Z",
    fill: "url(#paint26_linear_2_8031)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M147.225 75.9437C147.225 75.9437 146.444 71.6727 148.12 71.1672C149.796 70.6617 151.908 72.2699 151.794 72.3845C151.679 72.4991 147.225 75.9437 147.225 75.9437Z",
    fill: "url(#paint27_linear_2_8031)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M265.557 72.3846C265.557 72.3846 269.162 70.8234 270.494 73.4873C271.826 76.1513 269.92 77.4374 269.92 77.4374L265.557 72.3846Z",
    fill: "url(#paint28_linear_2_8031)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M191.704 174.013C185.303 176.299 180.844 187.159 177.415 194.589C176.272 194.589 156.267 194.589 154.553 201.448C153.094 207.282 164.841 218.023 170.556 222.595C168.842 227.168 165.412 241.457 168.842 244.886C172.788 248.833 185.798 241.076 192.276 236.313C199.134 241.457 211.137 248.316 215.71 244.886C219.71 241.885 216.472 229.073 214.566 222.595C223.711 215.279 230.57 206.02 229.999 202.019C229.155 196.117 214.566 194.589 207.136 194.017C203.707 186.015 197.648 173.555 191.704 174.013Z",
    stroke: "#FDD47F",
    strokeWidth: 3
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M208.841 232.487C211.628 235.294 220.936 245.238 215.113 247.285C208.32 249.685 196.737 243.089 193.032 243.257C189.327 243.434 178.559 249.34 173.623 249.309C168.687 249.278 168.197 246.544 168.229 246.346C168.27 246.147 167.372 240.868 167.175 240.763C167.071 240.711 167.206 236.871 167.28 233.073C180.928 232.216 194.994 232.028 208.841 232.487Z",
    fill: "#6E1A46"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M217.336 238.069L209.207 232.507C211.879 232.601 214.529 232.716 217.179 232.861C217.118 235.752 217.336 238.069 217.336 238.069Z",
    fill: "#381F91"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M214.181 224.461C214.181 224.461 216.683 231.664 217.334 238.067C217.734 242.006 217.431 245.632 215.41 247.099C210.109 250.956 192.201 238.104 192.201 238.104C192.201 238.104 174.294 250.955 168.993 247.099C163.693 243.249 170.222 224.461 170.222 224.461C170.222 224.461 152.626 209.189 154.646 202.955C154.876 202.26 155.335 201.622 155.98 201.067C157.904 199.357 161.451 198.218 165.099 197.454C165.773 197.313 166.446 197.187 167.113 197.077C167.128 197.077 167.15 197.07 167.173 197.07C172.459 196.16 177.397 195.982 177.397 195.982C177.397 195.982 180.573 188.158 184.555 182.228C186.983 178.601 189.715 175.676 192.202 175.676C194.268 175.676 196.496 177.69 198.583 180.444C203.128 186.448 207.007 195.982 207.007 195.982C207.007 195.982 209.258 196.064 212.353 196.397C214.329 196.605 216.647 196.924 218.948 197.382C223.945 198.389 228.823 200.092 229.757 202.956C231.777 209.188 214.181 224.461 214.181 224.461Z",
    fill: "url(#paint29_radial_2_8031)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M209.637 219.994C209.637 219.994 214.446 233.832 210.542 236.668C206.638 239.509 193.449 230.044 193.449 230.044C193.449 230.044 180.26 239.509 176.356 236.668C172.452 233.833 177.261 219.994 177.261 219.994C177.261 219.994 164.302 208.746 165.789 204.155C165.958 203.643 166.296 203.174 166.771 202.765C168.45 201.276 171.792 200.371 174.971 199.826C174.981 199.826 174.999 199.82 175.015 199.82C178.907 199.149 182.545 199.019 182.545 199.019C182.545 199.019 184.884 193.255 187.817 188.888C189.606 186.216 191.617 184.062 193.449 184.062C194.97 184.062 196.612 185.545 198.149 187.573C201.497 191.995 204.354 199.017 204.354 199.017C204.354 199.017 206.011 199.077 208.29 199.322C209.746 199.475 211.453 199.71 213.148 200.048C216.829 200.79 220.421 202.044 221.109 204.154C222.597 208.746 209.637 219.994 209.637 219.994Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M214.181 224.46C214.181 224.46 220.71 243.249 215.41 247.098C210.109 250.955 192.201 238.103 192.201 238.103C192.201 238.103 174.294 250.954 168.993 247.098C167.661 246.128 167.076 244.219 166.951 241.894C166.566 234.988 170.223 224.46 170.223 224.46C170.223 224.46 156.431 212.49 154.67 205.412C154.44 204.502 154.417 203.672 154.648 202.955C154.877 202.259 155.337 201.622 155.981 201.067C155.87 201.386 155.766 201.718 155.677 202.066C155.521 202.689 155.625 203.725 156.054 205.02C157.061 208.1 159.897 212.645 165.381 216.518C169.579 219.478 175.257 222.032 175.257 222.032C175.257 222.032 166.707 233.44 168.017 241.346C168.188 242.382 168.528 243.36 169.083 244.24C174.561 252.983 189.522 236.423 191.877 233.706C192.091 233.469 192.202 233.336 192.202 233.336C192.202 233.336 198.961 246.476 212.19 245.765C224.523 245.099 209.14 221.439 209.392 221.41C210.503 221.292 222.384 215.613 227.485 206.204C227.81 205.605 228.025 205.042 228.129 204.516C228.899 200.836 224.738 198.756 218.949 197.379C223.946 198.386 228.825 200.089 229.758 202.954C229.854 203.249 229.906 203.568 229.921 203.902C230.141 210.602 214.181 224.46 214.181 224.46Z",
    fill: "#E07090"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M184.554 182.227C181.215 189.778 180.63 197.662 180.63 197.662C180.63 197.662 177.824 197.047 174.553 196.825C171.622 196.632 167.897 196.995 167.172 197.069C172.457 196.159 177.396 195.981 177.396 195.981C177.396 195.981 180.571 188.157 184.554 182.227Z",
    fill: "#E07090"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M212.351 196.397C206.178 196.804 204.127 198.137 204.127 198.137C204.127 198.137 204.127 195.916 203.224 192.051C202.55 189.187 199.944 183.367 198.582 180.444C203.127 186.448 207.006 195.983 207.006 195.983C207.006 195.983 209.258 196.063 212.351 196.397Z",
    fill: "#E07090"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.919 203.903C230.142 210.603 214.181 224.46 214.181 224.46C211.937 221.876 209.392 221.41 209.392 221.41C210.502 221.292 222.384 215.613 227.484 206.204C227.81 205.605 228.024 205.042 228.129 204.516C228.794 204.266 229.401 204.059 229.919 203.903Z",
    fill: "url(#paint30_linear_2_8031)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M192.201 238.104C192.201 238.104 174.294 250.954 168.993 247.098C167.661 246.129 167.076 244.219 166.951 241.894C167.291 241.717 167.646 241.532 168.017 241.346C168.188 242.383 168.528 243.36 169.083 244.241C174.561 252.983 189.522 236.423 191.877 233.706C191.713 234.195 191.653 235.365 192.201 238.104Z",
    fill: "url(#paint31_linear_2_8031)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M175.256 222.032C175.256 222.032 171.998 222.631 170.221 224.46C170.221 224.46 156.429 212.489 154.667 205.412L156.052 205.02C157.058 208.1 159.894 212.645 165.379 216.517C169.578 219.478 175.256 222.032 175.256 222.032Z",
    fill: "url(#paint32_linear_2_8031)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M214.181 224.461C214.181 224.461 216.683 231.664 217.334 238.067C201.855 212.372 181.859 201.719 165.099 197.455C165.773 197.314 166.446 197.187 167.113 197.077C167.128 197.077 167.15 197.071 167.173 197.071C172.458 196.16 177.397 195.983 177.397 195.983C177.397 195.983 180.573 188.158 184.555 182.228C186.983 178.602 189.715 175.676 192.202 175.676C194.268 175.676 196.496 177.69 198.583 180.444C203.128 186.448 207.007 195.983 207.007 195.983C207.007 195.983 209.258 196.064 212.352 196.398C214.329 196.605 216.646 196.924 218.948 197.382C223.945 198.389 228.823 200.092 229.756 202.957C231.777 209.188 214.181 224.461 214.181 224.461Z",
    fill: "url(#paint33_radial_2_8031)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.331 222.601C172.422 223.577 167.029 241.833 172.767 244.115C178.504 246.398 192.2 233.751 191.335 230.914C190.471 228.075 180.046 222.061 177.331 222.601Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M191.638 176.708C187.986 177.139 185.618 185.139 188.661 192.254C191.705 199.369 203.138 202.124 203.754 198.711C204.372 195.297 199.303 175.802 191.638 176.708Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M195.078 179.464C192.383 178.731 190.529 186.415 193.449 191.637C196.369 196.861 203.14 198.258 203.263 196.326C203.385 194.393 200.218 180.862 195.078 179.464Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M156.994 203.213C156.264 203.637 158.418 200.262 164.274 198.936C173.168 196.922 182.081 199.019 181.095 199.553C180.108 200.087 166.124 197.907 156.994 203.213Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M204.999 199.081C204.999 199.081 209.78 197.754 215.302 197.939C220.823 198.124 225.789 201.27 225.172 201.27C224.556 201.27 220.946 199.204 204.999 199.081Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M174.216 225.584C174.216 225.584 171.038 230.274 170.453 233.478C169.867 236.681 170.514 242.048 170.854 241.494C171.193 240.939 169.589 237.652 174.216 225.584Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M101.327 195.437C97.361 198.063 96.1525 206.189 95.0682 211.811C94.2916 212.003 80.7006 215.356 80.6854 220.304C80.6724 224.512 90.4535 229.84 95.1031 231.988C94.7047 235.382 94.77 245.665 97.6748 247.42C101.018 249.44 108.556 241.989 112.158 237.667C117.68 240.012 126.985 242.66 129.516 239.564C131.732 236.854 127.383 228.693 125.003 224.611C129.99 218.108 133.097 210.667 132.038 208.045C130.476 204.177 120.308 205.584 115.165 206.441C111.493 201.58 105.289 194.13 101.327 195.437Z",
    stroke: "#FDD47F",
    strokeWidth: 3
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M129.538 238.737C129.538 238.737 129.007 242.63 126.721 242.943C124.435 243.256 113.823 241.576 113.27 241.461C112.718 241.336 105.194 247.868 101.301 248.671C97.4185 249.475 96.302 246.177 96.302 246.177L95.4675 240.135C105.423 237.818 116.379 236.023 127.889 234.729H127.899L129.538 238.737Z",
    fill: "#6E1A46"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M124.313 225.382C124.313 225.382 127.187 229.756 128.696 233.907C129.623 236.461 130.03 238.926 128.932 240.241C126.053 243.697 111.979 238.152 111.979 238.152C111.979 238.152 102.22 249.71 98.0455 248.033C93.8719 246.362 95.0629 232.763 95.0629 232.763C95.0629 232.763 80.7894 225.556 81.0886 221.068C81.1242 220.566 81.3225 220.066 81.6583 219.588C82.6521 218.127 84.8198 216.773 87.1203 215.653C87.5445 215.447 87.972 215.249 88.3973 215.064C88.4065 215.061 88.4202 215.052 88.4351 215.049C91.7995 213.555 95.0549 212.608 95.0549 212.608C95.0549 212.608 95.8539 206.869 97.5091 202.254C98.5155 199.433 99.8429 197.028 101.498 196.611C102.873 196.265 104.693 197.23 106.544 198.712C110.577 201.945 114.758 207.637 114.758 207.637C114.758 207.637 116.269 207.314 118.384 207.016C119.734 206.822 121.329 206.644 122.938 206.563C126.432 206.394 129.964 206.707 131.066 208.458C133.458 212.267 124.313 225.382 124.313 225.382Z",
    fill: "url(#paint34_radial_2_8031)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M120.539 223.173C120.539 223.173 126.062 231.575 123.94 234.116C121.819 236.662 111.453 232.577 111.453 232.577C111.453 232.577 104.266 241.09 101.192 239.855C98.1177 238.624 98.9946 228.609 98.9946 228.609C98.9946 228.609 88.4821 223.301 88.7021 219.996C88.7285 219.627 88.8752 219.258 89.1217 218.906C89.9894 217.633 92.0619 216.47 94.0851 215.574C94.0919 215.571 94.1023 215.566 94.1137 215.562C96.592 214.462 98.99 213.765 98.99 213.765C98.99 213.765 99.5792 209.537 100.798 206.139C101.539 204.06 102.516 202.289 103.736 201.982C104.748 201.727 106.089 202.438 107.453 203.53C110.423 205.91 113.503 210.104 113.503 210.104C113.503 210.104 114.616 209.865 116.174 209.646C117.168 209.503 118.343 209.373 119.528 209.313C122.101 209.188 124.702 209.419 125.514 210.708C127.274 213.513 120.539 223.173 120.539 223.173Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.313 225.382C124.313 225.382 131.811 236.787 128.931 240.239C126.051 243.695 111.977 238.15 111.977 238.15C111.977 238.15 102.219 249.708 98.0444 248.031C96.9944 247.609 96.2848 246.437 95.8114 244.911C94.3957 240.38 95.0617 232.762 95.0617 232.762C95.0617 232.762 83.8752 227.112 81.515 222.699C81.2089 222.131 81.0553 221.583 81.0874 221.066C81.123 220.564 81.3213 220.064 81.6571 219.586C81.6365 219.817 81.6239 220.056 81.6227 220.303C81.6239 220.743 81.8669 221.415 82.3701 222.205C83.5577 224.084 86.2067 226.633 90.5064 228.289C93.7962 229.554 98.0031 230.301 98.0031 230.301C98.0031 230.301 94.2284 239.328 96.4281 244.368C96.7158 245.029 97.1055 245.622 97.6237 246.115C102.737 251.013 109.912 237.481 111.023 235.278C111.126 235.084 111.177 234.976 111.177 234.976C111.177 234.976 117.881 242.585 126.564 239.892C134.659 237.378 120.451 224.217 120.612 224.155C121.331 223.891 128.284 218.117 130.099 211C130.215 210.546 130.263 210.135 130.245 209.769C130.139 207.191 127.021 206.505 122.938 206.561C126.432 206.393 129.964 206.706 131.066 208.456C131.18 208.637 131.268 208.84 131.333 209.059C132.606 213.481 124.313 225.382 124.313 225.382Z",
    fill: "#E07090"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M97.508 202.254C96.5542 207.839 97.4885 213.184 97.4885 213.184C97.4885 213.184 95.518 213.246 93.3034 213.648C91.3203 214.013 88.904 214.879 88.4329 215.05C91.7972 213.557 95.0526 212.61 95.0526 212.61C95.0526 212.61 95.8539 206.869 97.508 202.254Z",
    fill: "#E07090"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M118.384 207.016C114.344 208.324 113.203 209.555 113.203 209.555C113.203 209.555 112.83 208.077 111.58 205.657C110.65 203.865 107.939 200.43 106.542 198.713C110.574 201.946 114.756 207.638 114.756 207.638C114.756 207.638 116.269 207.314 118.384 207.016Z",
    fill: "#E07090"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.334 209.062C132.606 213.482 124.313 225.384 124.313 225.384C122.387 224.041 120.614 224.158 120.614 224.158C121.332 223.894 128.286 218.12 130.1 211.003C130.216 210.549 130.264 210.138 130.246 209.771C130.646 209.492 131.015 209.252 131.334 209.062Z",
    fill: "url(#paint35_linear_2_8031)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.978 238.152C111.978 238.152 102.219 249.71 98.0445 248.033C96.9945 247.611 96.2849 246.439 95.8115 244.913C96.0087 244.738 96.2139 244.554 96.4294 244.37C96.7171 245.031 97.1068 245.624 97.6249 246.117C102.738 251.015 109.913 237.483 111.024 235.28C110.996 235.633 111.153 236.421 111.978 238.152Z",
    fill: "url(#paint36_linear_2_8031)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M98.0042 230.303C98.0042 230.303 95.9375 231.248 95.0628 232.764C95.0628 232.764 83.8763 227.114 81.5161 222.7L82.3712 222.206C83.5588 224.086 86.2078 226.634 90.5075 228.291C93.7962 229.556 98.0042 230.303 98.0042 230.303Z",
    fill: "url(#paint37_linear_2_8031)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.313 225.382C124.313 225.382 127.187 229.756 128.696 233.907C114.082 219.408 98.9878 215.677 87.1204 215.653C87.5445 215.447 87.972 215.249 88.3973 215.064C88.4065 215.061 88.4202 215.052 88.4351 215.049C91.7995 213.555 95.0549 212.608 95.0549 212.608C95.0549 212.608 95.8539 206.869 97.5091 202.254C98.5155 199.433 99.8429 197.028 101.498 196.611C102.873 196.265 104.693 197.23 106.544 198.712C110.577 201.945 114.758 207.637 114.758 207.637C114.758 207.637 116.269 207.314 118.384 207.016C119.734 206.822 121.329 206.644 122.938 206.563C126.432 206.394 129.964 206.707 131.066 208.458C133.458 212.267 124.313 225.382 124.313 225.382Z",
    fill: "url(#paint38_radial_2_8031)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M99.4807 230.332C96.3778 231.806 95.8539 244.859 100.055 245.415C104.256 245.97 111.246 235.256 110.195 233.513C109.143 231.768 101.196 229.517 99.4807 230.332Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M101.295 197.393C98.9374 198.293 98.7047 204.014 101.925 208.237C105.145 212.461 113.214 212.374 113.053 210C112.89 207.624 106.244 195.504 101.295 197.393Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M104.046 198.648C102.13 198.612 102.186 204.037 105.006 207.022C107.826 210.006 112.565 209.8 112.322 208.493C112.081 207.187 107.702 198.714 104.046 198.648Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6921 220.846C82.2783 221.25 83.1438 218.642 86.8176 216.777C92.3977 213.944 98.6816 213.843 98.1142 214.363C97.5479 214.885 87.8767 215.782 82.6921 220.846Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M113.942 210.036C113.942 210.036 116.901 208.351 120.605 207.546C124.31 206.743 128.143 208.002 127.733 208.106C127.323 208.21 124.574 207.441 113.942 210.036Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9079 232.839C97.9079 232.839 96.5817 236.494 96.7295 238.723C96.8774 240.953 98.2094 244.416 98.3424 243.989C98.4742 243.564 96.8556 241.646 97.9079 232.839Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M283.824 240.219C283.679 240.344 289.918 246.511 286.35 248.035C282.771 249.549 273.963 241.952 271.491 241.617C269.017 241.284 263.477 242.807 260.179 242.525C256.881 242.233 255.504 240.793 255.452 240.303C255.399 239.802 255.002 236.765 254.951 236.494C254.93 236.4 255.086 235.471 255.306 234.218C267.358 235.408 278.868 237.14 289.366 239.415C288.853 239.478 283.949 240.104 283.824 240.219Z",
    fill: "#6E1A46"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M289.301 232.757C289.301 232.757 289.767 237.97 289.134 242.341C288.744 245.029 287.937 247.394 286.347 248.034C282.176 249.719 272.396 238.179 272.396 238.179C272.396 238.179 258.334 243.751 255.447 240.301C252.56 236.855 260.037 225.435 260.037 225.435C260.037 225.435 250.867 212.336 253.251 208.523C253.519 208.097 253.932 207.75 254.452 207.488C256.018 206.67 258.57 206.502 261.126 206.603C261.598 206.621 262.067 206.65 262.529 206.686C262.539 206.689 262.555 206.688 262.569 206.691C266.239 206.965 269.557 207.67 269.557 207.67C269.557 207.67 272.975 202.99 276.614 199.706C278.835 197.695 281.141 196.204 282.796 196.618C284.172 196.961 285.319 198.673 286.25 200.854C288.276 205.608 289.269 212.602 289.269 212.602C289.269 212.602 290.754 213.031 292.759 213.769C294.04 214.237 295.529 214.834 296.986 215.524C300.145 217.027 303.109 218.973 303.253 221.036C303.561 225.522 289.301 232.757 289.301 232.757Z",
    fill: "url(#paint39_radial_2_8031)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M287.02 229.027C287.02 229.027 287.917 239.041 284.845 240.277C281.773 241.518 274.57 233.019 274.57 233.019C274.57 233.019 264.212 237.123 262.087 234.582C259.96 232.044 265.467 223.632 265.467 223.632C265.467 223.632 258.713 213.985 260.469 211.177C260.667 210.864 260.97 210.608 261.354 210.414C262.72 209.704 265.096 209.658 267.303 209.824C267.31 209.826 267.323 209.825 267.333 209.828C270.036 210.029 272.48 210.549 272.48 210.549C272.48 210.549 274.997 207.102 277.678 204.683C279.314 203.202 281.012 202.104 282.231 202.409C283.243 202.662 284.089 203.923 284.775 205.529C286.267 209.031 286.999 214.181 286.999 214.181C286.999 214.181 288.092 214.498 289.569 215.041C290.512 215.385 291.609 215.825 292.682 216.333C295.009 217.44 297.191 218.873 297.297 220.392C297.523 223.698 287.02 229.027 287.02 229.027Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M289.301 232.757C289.301 232.757 290.518 246.353 286.347 248.032C282.176 249.717 272.396 238.177 272.396 238.177C272.396 238.177 258.334 243.749 255.447 240.299C254.722 239.431 254.651 238.063 254.954 236.495C255.848 231.833 260.037 225.433 260.037 225.433C260.037 225.433 252.85 215.166 252.855 210.161C252.854 209.517 252.978 208.961 253.25 208.521C253.518 208.096 253.931 207.748 254.451 207.486C254.324 207.679 254.2 207.883 254.082 208.1C253.874 208.489 253.771 209.196 253.841 210.129C253.998 212.347 255.129 215.846 258.135 219.337C260.436 222.008 263.791 224.654 263.791 224.654C263.791 224.654 256.198 230.824 255.753 236.305C255.694 237.024 255.758 237.731 255.98 238.41C258.171 245.143 270.89 236.612 272.91 235.195C273.092 235.073 273.188 235.002 273.188 235.002C273.188 235.002 275.499 244.876 284.424 246.607C292.746 248.219 286.446 229.905 286.619 229.926C287.378 230.033 296.234 228.232 301.198 222.818C301.514 222.473 301.751 222.135 301.907 221.802C303.033 219.48 300.609 217.402 296.985 215.521C300.144 217.024 303.108 218.97 303.252 221.032C303.267 221.246 303.248 221.466 303.202 221.69C302.236 226.19 289.301 232.757 289.301 232.757Z",
    fill: "#E07090"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M276.614 199.706C273.134 204.177 271.431 209.328 271.431 209.328C271.431 209.328 269.666 208.451 267.524 207.759C265.604 207.142 263.065 206.764 262.57 206.692C266.24 206.966 269.558 207.671 269.558 207.671C269.558 207.671 272.975 202.991 276.614 199.706Z",
    fill: "#E07090"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M292.76 213.77C288.582 213.012 286.995 213.558 286.995 213.558C286.995 213.558 287.365 212.079 287.408 209.357C287.436 207.337 286.671 203.029 286.251 200.856C288.277 205.609 289.271 212.604 289.271 212.604C289.271 212.604 290.755 213.033 292.76 213.77Z",
    fill: "#E07090"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M303.205 221.694C302.236 226.191 289.301 232.758 289.301 232.758C288.239 230.663 286.621 229.929 286.621 229.929C287.38 230.035 296.236 228.234 301.2 222.82C301.516 222.475 301.753 222.137 301.909 221.804C302.394 221.748 302.833 221.711 303.205 221.694Z",
    fill: "url(#paint40_linear_2_8031)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M272.396 238.18C272.396 238.18 258.333 243.752 255.447 240.302C254.722 239.434 254.65 238.065 254.954 236.497C255.211 236.435 255.478 236.372 255.755 236.31C255.696 237.029 255.76 237.736 255.982 238.415C258.173 245.148 270.892 236.616 272.912 235.2C272.723 235.495 272.488 236.264 272.396 238.18Z",
    fill: "url(#paint41_linear_2_8031)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M263.793 224.657C263.793 224.657 261.525 224.513 260.037 225.435C260.037 225.435 252.85 215.168 252.855 210.163L253.842 210.132C253.999 212.35 255.13 215.849 258.136 219.34C260.438 222.01 263.793 224.657 263.793 224.657Z",
    fill: "url(#paint42_linear_2_8031)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M289.302 232.758C289.302 232.758 289.767 237.97 289.134 242.342C283.11 222.657 271.573 212.233 261.126 206.602C261.598 206.62 262.067 206.649 262.529 206.685C262.539 206.688 262.555 206.687 262.569 206.69C266.24 206.964 269.557 207.669 269.557 207.669C269.557 207.669 272.975 202.989 276.615 199.705C278.835 197.694 281.141 196.203 282.796 196.617C284.172 196.96 285.319 198.672 286.25 200.853C288.276 205.607 289.269 212.601 289.269 212.601C289.269 212.601 290.754 213.03 292.759 213.768C294.04 214.236 295.529 214.833 296.986 215.523C300.145 217.026 303.11 218.972 303.253 221.035C303.561 225.522 289.302 232.758 289.302 232.758Z",
    fill: "url(#paint43_radial_2_8031)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M265.079 225.379C261.649 225.211 255.016 236.466 258.456 238.942C261.895 241.418 273.119 235.28 273.017 233.246C272.915 231.214 266.977 225.472 265.079 225.379Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M282.251 197.212C279.747 196.891 276.838 201.822 277.679 207.065C278.52 212.309 285.672 216.048 286.652 213.878C287.631 211.708 287.504 197.887 282.251 197.212Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M284.081 199.619C282.41 198.682 279.895 203.489 280.968 207.451C282.042 211.415 286.315 213.474 286.72 212.207C287.125 210.942 287.27 201.407 284.081 199.619Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M254.771 209.086C254.215 209.246 256.211 207.358 260.329 207.451C266.586 207.592 272.171 210.473 271.425 210.664C270.679 210.855 261.732 207.074 254.771 209.086Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M287.418 214.332C287.418 214.332 290.821 214.246 294.466 215.289C298.112 216.332 300.894 219.254 300.482 219.151C300.072 219.048 298.014 217.071 287.418 214.332Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M262.508 226.848C262.508 226.848 259.612 229.441 258.688 231.476C257.764 233.51 257.301 237.192 257.619 236.878C257.938 236.566 257.418 234.112 262.508 226.848Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M282.418 195.142C277.685 195.623 272.836 202.253 269.261 206.727C268.485 206.535 254.893 203.182 252.579 207.554C250.61 211.274 256.79 220.54 259.907 224.604C257.976 227.424 253.251 236.557 255.006 239.461C257.026 242.804 267.165 239.715 272.364 237.564C276.161 242.209 283.166 248.88 286.848 247.317C290.069 245.949 290.016 236.701 289.807 231.981C297.247 228.544 303.458 223.402 303.741 220.588C304.157 216.437 294.502 212.954 289.549 211.32C288.561 205.309 286.533 195.828 282.418 195.142Z",
    stroke: "#FDD47F",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_8031",
    x1: 177.337,
    y1: 71.7713,
    x2: 181.134,
    y2: 156.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0824,
    stopColor: "#144533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4952,
    stopColor: "#39721E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8146,
    stopColor: "#508E12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59980D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_8031",
    x1: 192.225,
    y1: 82.5129,
    x2: 195.403,
    y2: 153.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0824,
    stopColor: "#144533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4952,
    stopColor: "#39721E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8146,
    stopColor: "#508E12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59980D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_8031",
    x1: -19.896,
    y1: 18.6691,
    x2: 83.9579,
    y2: 105.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2713,
    stopColor: "#FCD400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5769,
    stopColor: "#FCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8309,
    stopColor: "#FC9E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_8031",
    x1: 17.7616,
    y1: 10.7898,
    x2: 51.9095,
    y2: 82.6803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    stopColor: "#FAD204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    stopColor: "#EF971F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    stopColor: "#E76835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7196,
    stopColor: "#E04644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#DC314E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_8031",
    x1: 1.71099,
    y1: 45.8799,
    x2: 38.2553,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    stopColor: "#FAD204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    stopColor: "#EF971F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    stopColor: "#E76835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7196,
    stopColor: "#E04644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#DC314E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_8031",
    x1: -1.35663,
    y1: 82.4057,
    x2: 70.5337,
    y2: 120.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    stopColor: "#FAD204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    stopColor: "#EF971F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    stopColor: "#E76835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7196,
    stopColor: "#E04644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#DC314E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_8031",
    x1: 52.0985,
    y1: 67.1209,
    x2: 13.3574,
    y2: 33.9713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_8031",
    x1: 34.781,
    y1: 88.9607,
    x2: 1.43159,
    y2: 70.3889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_8031",
    x1: 68.2394,
    y1: 111.785,
    x2: 2.14025,
    y2: 100.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_8031",
    x1: 390.895,
    y1: 18.6689,
    x2: 287.041,
    y2: 105.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2713,
    stopColor: "#FCD400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5769,
    stopColor: "#FCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8309,
    stopColor: "#FC9E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_8031",
    x1: 352.703,
    y1: 12.8613,
    x2: 322.549,
    y2: 70.9729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    stopColor: "#FAD204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    stopColor: "#EF971F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    stopColor: "#E76835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7196,
    stopColor: "#E04644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#DC314E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_8031",
    x1: 369.289,
    y1: 49.3757,
    x2: 339.535,
    y2: 92.7098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    stopColor: "#FAD204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    stopColor: "#EF971F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    stopColor: "#E76835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7196,
    stopColor: "#E04644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#DC314E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_8031",
    x1: 370.31,
    y1: 81.3067,
    x2: 295.025,
    y2: 125.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0327,
    stopColor: "#FAD204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2844,
    stopColor: "#EF971F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    stopColor: "#E76835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7196,
    stopColor: "#E04644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#DC314E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_8031",
    x1: 320.779,
    y1: 69.4014,
    x2: 356.924,
    y2: 32.6573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_8031",
    x1: 333.422,
    y1: 94.1172,
    x2: 370.965,
    y2: 65.9601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_8031",
    x1: 297.729,
    y1: 112.342,
    x2: 366.025,
    y2: 101.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_8031",
    x1: 184.773,
    y1: 134.244,
    x2: 184.773,
    y2: 53.1991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_8031",
    x1: 55.6587,
    y1: 90.922,
    x2: 313.886,
    y2: 90.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_8031",
    x1: 186.265,
    y1: 23.0263,
    x2: 186.265,
    y2: 100.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2D52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_8031",
    x1: 96.1877,
    y1: 101.548,
    x2: 96.1877,
    y2: 40.3721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2818,
    stopColor: "#D2D1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7124,
    stopColor: "#E7E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2_8031",
    x1: 122.94,
    y1: 101.549,
    x2: 122.94,
    y2: 40.3723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2818,
    stopColor: "#D2D1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7124,
    stopColor: "#E7E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2_8031",
    x1: 150.643,
    y1: 101.55,
    x2: 150.643,
    y2: 40.3724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2818,
    stopColor: "#D2D1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7124,
    stopColor: "#E7E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_8031",
    x1: 180.825,
    y1: 101.549,
    x2: 180.825,
    y2: 40.3721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2818,
    stopColor: "#D2D1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7124,
    stopColor: "#E7E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2_8031",
    x1: 212.27,
    y1: 101.549,
    x2: 212.27,
    y2: 40.3721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2818,
    stopColor: "#D2D1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7124,
    stopColor: "#E7E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2_8031",
    x1: 245.932,
    y1: 101.549,
    x2: 245.932,
    y2: 40.3731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2818,
    stopColor: "#D2D1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7124,
    stopColor: "#E7E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2_8031",
    x1: 277.487,
    y1: 101.549,
    x2: 277.487,
    y2: 40.3726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2818,
    stopColor: "#D2D1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7124,
    stopColor: "#E7E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2_8031",
    x1: 96.3782,
    y1: 97.5493,
    x2: 96.3655,
    y2: 103.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2D52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2_8031",
    x1: 149.426,
    y1: 70.9078,
    x2: 149.407,
    y2: 79.1249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2D52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2_8031",
    x1: 268.267,
    y1: 71.7469,
    x2: 268.245,
    y2: 81.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2D52"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2_8031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(201.577 201.304) scale(67.3187 67.3187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2713,
    stopColor: "#FCD400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5769,
    stopColor: "#FCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8309,
    stopColor: "#FC9E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2_8031",
    x1: 209.391,
    y1: 214.182,
    x2: 229.921,
    y2: 214.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2_8031",
    x1: 193.224,
    y1: 235.593,
    x2: 167.807,
    y2: 245.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2_8031",
    x1: 174.194,
    y1: 226.072,
    x2: 157.723,
    y2: 206.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2_8031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.508 206.871) scale(31.8085 31.8085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEE5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CB52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E8736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2_8031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.038 212.091) rotate(-14.1585) scale(46.1986 46.1986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2713,
    stopColor: "#FCD400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5769,
    stopColor: "#FCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8309,
    stopColor: "#FC9E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2_8031",
    x1: 119.399,
    y1: 219.347,
    x2: 133.06,
    y2: 215.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2_8031",
    x1: 112.237,
    y1: 236.31,
    x2: 97.0538,
    y2: 247.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2_8031",
    x1: 97.9753,
    y1: 233.169,
    x2: 83.6494,
    y2: 222.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2_8031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.265 216.478) rotate(-14.1585) scale(21.8287 21.8287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEE5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CB52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E8736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2_8031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(284.769 215.242) rotate(14.0515) scale(46.1986 46.1985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2713,
    stopColor: "#FCD400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5769,
    stopColor: "#FCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8309,
    stopColor: "#FC9E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2_8031",
    x1: 287.826,
    y1: 225.117,
    x2: 301.493,
    y2: 228.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2_8031",
    x1: 273.495,
    y1: 236.678,
    x2: 254.858,
    y2: 239.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2_8031",
    x1: 262.413,
    y1: 227.168,
    x2: 254.788,
    y2: 211.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2_8031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(281.133 218.27) rotate(14.0515) scale(21.8288 21.8288)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEE5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CB52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E8736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVictory3Start);
export default __webpack_public_path__ + "static/media/victory3start.35bac2ef92987150355cb98a7c56648e.svg";
export { ForwardRef as ReactComponent };